import { gql } from '@apollo/client'

/*
 * Reviewee manage mutations (L40). The payload selects flags only — never `text` — so a manage
 * response can't write hidden text onto the normalized public review.
 */

const MANAGE_FLAGS = `
  id
  isFeatured
  isHidden
  isTextHidden
`

export const FEATURE_SESSION_REVIEW = gql`
  mutation FeatureSessionReview($input: FeatureSessionReviewInput!) {
    featureSessionReview(input: $input) {
      sessionReview {
        ${MANAGE_FLAGS}
      }
    }
  }
`

export const HIDE_SESSION_REVIEW = gql`
  mutation HideSessionReview($input: HideSessionReviewInput!) {
    hideSessionReview(input: $input) {
      sessionReview {
        ${MANAGE_FLAGS}
      }
    }
  }
`

export const HIDE_SESSION_REVIEW_TEXT = gql`
  mutation HideSessionReviewText($input: HideSessionReviewTextInput!) {
    hideSessionReviewText(input: $input) {
      sessionReview {
        ${MANAGE_FLAGS}
      }
    }
  }
`

export const REPORT_SESSION_REVIEW = gql`
  mutation ReportSessionReview($input: ReportSessionReviewInput!) {
    reportSessionReview(input: $input) {
      reported
      sessionReview {
        id
      }
    }
  }
`

export const SYNC_CLARITY_REVIEWS = gql`
  mutation SyncClarityReviews($input: SyncClarityReviewsInput!) {
    syncClarityReviews(input: $input) {
      sync {
        fetchedCount
        createdCount
        updatedCount
        restoredCount
        unchangedCount
        removedCount
        skippedCount
        syncedAt
      }
    }
  }
`

/** Ops sitewide hide (`hiddenByAdminAt`). Admin only. */
export const ADMIN_HIDE_SESSION_REVIEW = gql`
  mutation AdminHideSessionReview($input: AdminHideSessionReviewInput!) {
    adminHideSessionReview(input: $input) {
      rating {
        id
        ratingId
        hiddenAt
        hiddenByAdminAt
        featuredAt
      }
    }
  }
`
